import { request as _request, updateRequestConfig } from './request';

const getAwardList = params => {
  return _request({
    url: `/v3/vss/mall-reward/get-award-list`,
    method: 'post',
    params,
    header: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
};
/**
 * 获取商城奖励列表
 * @returns
 */
const getMallRewardList = params => {
  return _request({
    url: `/v3/vss/mall-reward/list`,
    method: 'post',
    params,
    header: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
};
/**
 * 获取奖励详情
 * @returns
 */
const getMallRewardInfo = params => {
  return _request({
    url: `/v3/vss/mall-reward/detail`,
    method: 'post',
    params,
    header: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
};

/**
 * 保存商城奖励
 */
const saveMallReward = params => {
  return _request({
    url: `/v3/vss/mall-reward/save`,
    method: 'post',
    params,
    header: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
};

/**
 * 删除商城奖励
 */
const delMallReward = params => {
  return _request({
    url: `/v3/vss/mall-reward/batch-delete`,
    method: 'post',
    params,
    header: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
};
/**
 * 推送商城奖励
 */
const pushMallReward = params => {
  return _request({
    url: `/v3/vss/mall-reward/push`,
    method: 'post',
    params,
    header: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
};
/**
 * 结束商城奖励
 */
const endMallReward = params => {
  return _request({
    url: `/v3/vss/mall-reward/end`,
    method: 'post',
    params,
    header: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
};
/**
 * 领取奖励用户记录
 */
const getRcordList = params => {
  return _request({
    url: `/v3/vss/mall-reward/record/list`,
    method: 'post',
    params,
    header: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
};
//导出领取记录
const exportRcord = params => {
  return _request({
    url: `/v3/vss/mall-reward/record/export`,
    method: 'post',
    params,
    header: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
};
// 统一导入API
export {
  getAwardList,
  getMallRewardList,
  getMallRewardInfo,
  saveMallReward,
  delMallReward,
  pushMallReward,
  endMallReward,
  getRcordList,
  exportRcord
};
